(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ResultSeriesSearch', ResultSeriesSearch);

    ResultSeriesSearch.$inject = ['$resource'];

    function ResultSeriesSearch($resource) {
        var resourceUrl =  'api/_search/result-series/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
